import { Outlet } from "react-router-dom";
import ThemeHeader from "../components/Theme/ThemeHeader";
import ThemeFooter from "../components/Theme/ThemeFooter";
import { useAuth } from "../provider/authprovider";
import { isTokenExpired } from "../utils/authflow";
import {getQueryparam} from "../components/Theme/UrlLoader";
import {useLocation } from 'react-router-dom';

const Layout = () => {
    const location = useLocation();
    const queryParam = getQueryparam(location);
    const container = {
        paddingTop: "50px"
    }

    const { userDetails } = useAuth();
    if (!userDetails.isLoggedIn || isTokenExpired()) {
        return <Outlet />
    }

    return (
        <>
           {queryParam==null &&  <ThemeHeader /> }
            <div className='container' style={container}>
                <Outlet />
            </div>
            {queryParam==null &&  <ThemeFooter />}
        </>
    )
};

export default Layout;
